import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-plus-btn" }
const _hoisted_2 = { class: "info-card" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "tool-tip" }
const _hoisted_5 = { class: "accordion-content beige info-card" }

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TandemAccordion',
  props: {
    tooltip: {},
    openByDefault: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


const open = ref(props.openByDefault || false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["accordion-block", { open: open.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "accordion-checkbox"),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "card", {}, () => [
          _createElementVNode("label", _hoisted_3, [
            _renderSlot(_ctx.$slots, "label")
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "btn-circle-small btn-accordion tooltip-container",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value)),
        "data-jquery-ignore": ""
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tooltip), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ], 2))
}
}

})